module.exports = __webpack_public_path__ + "static/media/aap_logo_white_in_red.a00359bb.svg";